export default __webpack_public_path__ + "static/media/maor-zur.1f2bd681.png";